import React, { useContext } from 'react'

export interface PostStreamOptions {
  baseUrl?: string
  signal?: AbortSignal
  onEvent: (eventName: string, data: any) => void
}

export interface ApiClient {
  get: <T = any>(path: string) => Promise<T>
  post: <T = any>(path: string, data?: unknown) => Promise<T>
  postStream: (path: string, data: unknown, opts: PostStreamOptions) => Promise<void>
}

export const ApiClientContext = React.createContext<ApiClient | null>(null)

export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext)
  if (!client) {
    throw new Error('useApiClient must be used within an ApiClientProvider')
  }
  return client
}
